import clsx from 'clsx';
import React, { FC } from 'react';

import { Icon } from '@/ui/Icon';

import cn from './StatusSwitcher.module.sass';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line no-shadow
enum SwitchStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
}

type StatusSwitcherProps = {
	/** Текущий статус */
	currentStatus: SwitchStatus;
	/** Событие, срабаывающее при изменении статуса */
	onStatusSwitch: (status: SwitchStatus) => void;
	disabled?: boolean;
};

const SWITCH_TEXT: Record<SwitchStatus, string> = {
	[SwitchStatus.ACTIVE]: 'user.active',
	[SwitchStatus.INACTIVE]: 'user.inactive',
};

const StatusSwitcher: FC<StatusSwitcherProps> = ({ currentStatus, onStatusSwitch, disabled }) => {
	const statusSwitchHandler = (status: SwitchStatus) => {
		if (status !== currentStatus) {
			onStatusSwitch(status);
		}
	};

	const { t } = useTranslation();

	return (
		<div className={cn.statusSwitcher}>
			{Object.values(SwitchStatus).map((status) => (
				<button
					key={status}
					data-testid={`button-status-switcher-${status}`}
					className={clsx(
						'relative',
						cn.status,
						{ [cn.selected]: status === currentStatus },
						{ 'opacity-50': disabled }
					)}
					onClick={() => statusSwitchHandler(status)}
					type="button"
					disabled={disabled}
				>
					<div className="absolute left-3 top-2">
						{status === SwitchStatus.ACTIVE ? <Icon name="eyeOpened" /> : <Icon name="eyeClosed" />}
					</div>
					{t(SWITCH_TEXT[status])}
				</button>
			))}
		</div>
	);
};

export { type StatusSwitcherProps, StatusSwitcher, SwitchStatus };
